import * as Effects from "redux-saga/effects";
import { ProjectActions } from "../reducers/project/actionsNames";

function* fetchContent(action) {
    const response = yield fetch(process.env.REACT_APP_API_URL + "/cart/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
            projects: [action.project],
        }),
    });

    let cart = yield response.json();

    yield Effects.put({
        type: ProjectActions.InsertCart,
        cart: cart,
    });
}

export default function* () {
    yield Effects.takeLatest(ProjectActions.InsertProject, fetchContent);
}
